<template>
    <div class="main">
        <div class="page_kv"></div>
        <div class="container">
            <h1 class="page_h1">登入</h1>
            <div class="form f-row">
                <formInupt label="手機號碼"  maxlength="12" v-model.trim="req.phone" :error="phoneError"/>
                <formInupt label="密碼" type="password"  maxlength="20" v-model.trim="req.password" :error="passwordError"/>

                <div class="form_grp f-col@lg:12">
                    <label class="option">
                        <input type="checkbox" name="remember" class="option_input" v-model="req.remember"> <span class="option_obj">記住我</span>
                    </label>
                </div>

                <div class="form_grp f-col@lg:12 reset-mg:b">
                    <a class="router_link" :href="'/forget_password'">忘記密碼</a>
                </div>

                <div class="form_grp f-col@lg:12 align:r mg-t-12">
                    <button class="btn w:full clr:primary btn btn-primary" @click="onSubmit">登入</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
    import Validator from "../../../libs/Validator";
    import Response from "../../../libs/Response";
    import formInupt from "../../../components/form/input";
    export default {
        name: "Welcome",
        components: {
            formInupt
        },
        data() {
            return {
                req:{
                    phone:'',
                    password:'',
                    remember: false,
                },
                phoneError:'',
                passwordError:'',


            }
        },
        methods: {
            async onSubmit() {
                const vm = this


                try {

                    const validator = Validator.make(vm.req, {
                        phone:['required'],
                        password: ['required']
                    })
                    if (validator.fails()) {
                        console.log(validator._errors)
                        throw Response.create({errors:validator.errors()},422)
                    }
                    vm.$store.commit('setLoadingStatus',true)
                    const res = await vm.$axios.get('/sanctum/csrf-cookie')
                    const res1 = await vm.$axios.post('login', vm.req)
                    if (res1.status === 204) {
                        window.location.replace('/home')
                    }else{
                        throw Response.create({errors:'請重新登入'},500)
                    }

                } catch (e) {
                    console.log(e)
                    const vm = this
                    vm.$store.commit('setLoadingStatus',false)
                    if(e.response.status === 422){
                        for (let key in e.response.data.errors) {
                            vm[`${key}Error`] = e.response.data.errors[key][0]
                        }
                    }

                }


            }
        }
    }
</script>

<style scoped>
    .main {
        height: 100%;
    }

    .container {
        padding: 30px 20px;
        height: 100%;
        background: #1b021f;
        color: #d6d6d6;
    }

    .login {
        color: #fff;
    }

    .router_link {
        font-size: 0.875rem;
    }

    .reset-mg\:b {
        margin-bottom: 0.75rem;
    }
</style>
